module.exports = __webpack_public_path__ + "media/images/regions/thumbnails/south_asia-bc2c73006cf0616e20d7de2763fe8c2a.png";